import {
  Megaphone,
  MessageSquare,
  Users,
  Settings,
  MessagesSquare,
  ChevronsLeft,
  ChevronsRight,
  LogOut,
  Bell,
  ChevronDown,
  ChevronUp,
  ChevronLeft,
  Menu,
  Check,
  Search,
  SendHorizontal,
  Paperclip,
  Smile,
  Image,
  Sticker,
  Plus,
  X,
  Calendar,
  Clock,
  FileVideo,
  CircleUserRound,
  ImagePlus,
  Link,
  Copy,
  EllipsisVertical,
  Sparkles,
  CircleQuestionMark,
  type LucideIcon,
} from 'lucide-react';
import type { IconName } from './iconPath';

const lucideIcons = {
  megaphone: { component: Megaphone, size: 24, color: 'currentColor' },
  menuLine: { component: MessageSquare, size: 24, color: 'currentColor' },
  menuUsers: { component: Users, size: 24, color: 'currentColor' },
  menuSettings: { component: Settings, size: 24, color: 'currentColor' },
  menuChat: { component: MessagesSquare, size: 24, color: 'currentColor' },
  chevronsLeft: { component: ChevronsLeft, size: 20, color: 'currentColor' },
  chevronsRight: { component: ChevronsRight, size: 20, color: 'currentColor' },
  signOut: { component: LogOut, size: 24, color: 'currentColor' },
  bell: { component: Bell, size: 24, color: 'currentColor' },
  chevronDown: { component: ChevronDown, size: 20, color: 'currentColor' },
  chevronUp: { component: ChevronUp, size: 20, color: 'currentColor' },
  chevronLeft: { component: ChevronLeft, size: 20, color: 'currentColor' },
  menuBars: { component: Menu, size: 20, color: 'currentColor' },
  check: { component: Check, size: 16, color: 'currentColor' },
  checkBold: { component: Check, size: 12, color: 'currentColor' },
  searchInput: { component: Search, size: 20, color: '#9CA3AF' },
  sendMessage: { component: SendHorizontal, size: 24, color: 'currentColor' },
  attach: { component: Paperclip, size: 24, color: 'currentColor' },
  emoji: { component: Smile, size: 24, color: 'currentColor' },
  image: { component: Image, size: 24, color: 'var(--color-neutral)' },
  sticker: { component: Sticker, size: 24, color: 'var(--color-neutral)' },
  plus: { component: Plus, size: 20, color: 'white' },
  close: { component: X, size: 24, color: 'var(--color-neutral)' },
  calendar: { component: Calendar, size: 22, color: 'var(--color-neutral-400)' },
  clock: { component: Clock, size: 20, color: 'var(--color-neutral-400)' },
  video: { component: FileVideo, size: 24, color: 'var(--color-neutral)' },
  userProfile: { component: CircleUserRound, size: 24, color: 'var(--color-neutral)' },
  imageUrl: { component: ImagePlus, size: 24, color: 'var(--color-neutral)' },
  videoUrl: { component: FileVideo, size: 24, color: 'var(--color-neutral)' },
  link: { component: Link, size: 24, color: 'currentColor' },
  copy: { component: Copy, size: 24, color: 'currentColor' },
  moreVertical: { component: EllipsisVertical, size: 16, color: 'currentColor' },
  aiStar: { component: Sparkles, size: 20, color: 'currentColor' },
  help: { component: CircleQuestionMark, size: 24, color: 'currentColor' },
} satisfies Record<IconName, { component: LucideIcon; size: number; color: string }>;

export default lucideIcons;
